module.exports = __webpack_public_path__ + "img/Methodical Organiser.64d80658.png";